import {lazy, trigger} from './lang.js';

export const trig = (args) => {
    let [stepData, stepNumber, time] = args;
    return trigger({
        stepData, stepNumber, time});
};

export const r_trig = (
    stepData, 
    note,
    duration=stepData.duration,
    _time) => {
  return (...args) => {
    let [s, stepNumber, time, effect] = args;
      if (_time) {
          time = _time;
      }
    let _stepData = effect.getStep(stepData);
    _stepData.transpose = lazy(note, ...args);
    _stepData.duration = lazy(duration, ...args);
    return trigger({
        stepData: _stepData, 
        time, 
        stepNumber
      });
  };
  
};
